import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import AttendanceRescheduleForm from './AttendanceRescheduleForm';
import { findRescheduleByToken } from '../../processes/attendance';
import { findSettingsByRescheduleToken } from '../../processes/company';
import { LINK_SESSION_STATUS } from '../../hooks/useAgendeaiLinkSession';
import { useAgendeaiLinkSession } from '../../hooks';
import { isNotReschedulable } from '../../utils/linkSession';

const getLinkErrorStatus = error => (isNotReschedulable(error) ? LINK_SESSION_STATUS.NOT_RESCHEDULABLE : null);

function AttendanceRescheduleFormContainer() {
	const history = useHistory();

	const onLoaded = useCallback(({ data }) => {
		history.replace(`/update-timegrid/${data.external_pages_token}`);
	}, [history]);

	const { status, reload } = useAgendeaiLinkSession({
		findLink: findRescheduleByToken,
		findSettings: findSettingsByRescheduleToken,
		getLinkErrorStatus,
		onLoaded
	});

	return <AttendanceRescheduleForm status={status} onRetryPress={reload} />;
}

export default AttendanceRescheduleFormContainer;
